<template>
	<section class="section-blog bg-gradient-to-b from-[#F3F7FD] pb-10">
		<AdaptiveContainer class="relative flex justify-between pt-10">
			<div class="w-full">
				<p class="text-dj-gray text-xl">{{ $t("blog.subtitle") }}</p>
				<div class="flex justify-between w-full">
					<BaseHeading type="h2" class="my-3 col-span-full relative">
						{{ blogTitle ? blogTitle : $t("blog.title") }}
					</BaseHeading>
					<div class="hidden sm:flex items-center">
						<BaseLink href="/blog" type="gray">
							{{ $t("blog.more") }}
							<span class="material-icons-outlined pl-2 text-base">arrow_forward</span>
						</BaseLink>
					</div>
				</div>
			</div>
		</AdaptiveContainer>
		<CarouselBlog :slideWidth="320" :blog-posts="blogData"></CarouselBlog>

		<!-- Mobile Button -->
		<div class="sm:hidden">
			<BaseLink type="secondary" href="/blog" class="w-full max-w-[345px] mx-auto mb-4">
				{{ $t("blog.more") }}
				<span class="material-icons-outlined pl-2 text-base">arrow_forward</span>
			</BaseLink>
		</div>
	</section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
	name: "Blog",
	props: {
		blogData: {
			type: Array,
			default: () => {
				return [];
			},
		},
		blogTitle: {
			type: String,
			default: null,
		},
	},
	setup() {
		return {};
	},
});
</script>
